export default {
  udis: null,
  usdExchange: null,
  fundTiie: null,
  fundTiieState: 'down',
  rgInterestBase: null,
  tiiePercentagePoints: null,
  tiieQueryDate: null,
  qualification: null,
  step: null,
  surplus: null,
  rgInterestSuggested: null,
}
